import { SIGNIN, SIGNOUT, SELECT_INSTITUTION, UPDATE_FIRST_TIME } from '../types';

/*
Here you build the function that will be used to create the reducer. 
This function is in charge of updating the state as indicated in the type. 
The payload is the new state that I am going to place.
*/
const authReducer = (state, action) => {

  const { payload, type } = action;

  switch (type) {
    case SIGNIN:
      return {
        ...state,
        ...payload
      };
    case SIGNOUT:
      return {
        ...state,
        user: payload,
        authorizedInstitutions: payload,
        currentInstitutionIndex: -1
      };
    case SELECT_INSTITUTION:
      return {
        ...state,
        currentInstitutionIndex: payload,
      };
    case UPDATE_FIRST_TIME:
      return {
        ...state,
        user: { ...state.user, isFirstTime: payload }
      };
    default:
      return state;
  }
};

export default authReducer;